import React from "react";
import { Link } from "react-router-dom";
import "./Legal.css";

const LegalLayout = ({ title, children }) => (
  <main className="legal-page">
    <div className="legal-shell">
      <article className="legal-card">
        <nav className="legal-nav" aria-label="Información legal">
          <Link to="/como-contratar">Cómo contratar</Link>
          <Link to="/terminos-y-condiciones">Términos y condiciones</Link>
          <Link to="/politica-de-reembolsos">Reembolsos</Link>
          <Link to="/politica-de-privacidad">Privacidad</Link>
          <Link to="/informacion-legal">Información legal</Link>
        </nav>
        <h1>{title}</h1>
        <p className="legal-updated">Última actualización: 29 de julio de 2026</p>
        {children}
      </article>
    </div>
  </main>
);

export default LegalLayout;
